export default "__VITE_ASSET__DfjM_48J__"